import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './Home';
import Terms from './Terms';
import Press from './Press';
import Events from './Events';
import Privacy from './Privacy';
import Support from './Support';

function App() {
  return (
    <div className="App">
        <Router>
            <Routes>
                <Route path='/' element={<Home/>} />
                <Route path='/terms' element={<Terms/>} />
                <Route path='/privacy' element={<Privacy/>} />
                <Route path='/press' element={<Press/>} />
                <Route path='/events' element={<Events/>} />
                <Route path='/support' element={<Support/>} />
            </Routes>
        </Router>
    </div>
  );
}

export default App;
